import AuthenticationService from 'authentication/AuthenticationService';
import AxiosProvider from 'api/axios/AxiosProvider';
import * as Sentry from '@sentry/react';
import { composeUrlWithParams } from 'pages/OpenBanking/goToTruelayerAuthUrl';

interface ResponseType {
  redirect_url: string;
}

interface Params {
  uuid: string;
  ukEmployment: boolean;
}

const goToKonfirAuthUrl = async ({ uuid, ukEmployment }: Params) => {
  const konfirUrl =
    process.env.REACT_APP_KONFIR_URI ?? 'http://homeppl.local:8000/api/konfir/verification_url/';
  console.log(`konfir hmppl url: ${process.env.REACT_APP_KONFIR_URI}`);
  const konfirAuthUrl = composeUrlWithParams(konfirUrl || '', {
    object_uuid: uuid,
    ukEmployment: ukEmployment.toString(),
  });
  const token = AuthenticationService.accessToken;

  const response = await AxiosProvider.get<ResponseType>(konfirAuthUrl, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response || !response?.data?.redirect_url) {
    Sentry.captureException('No konfir response', { tags: { category: 'node-api' } });
    throw new Error('No response from call to start konfir');
  }

  window.location.replace(response.data.redirect_url);
};

export default goToKonfirAuthUrl;
